import React from 'react';
import { Shield } from 'lucide-react';

const PrivacySecurity = () => {
  return (
    <section className="privacy-security-section py-10 px-4 md:py-12 bg-[#0a0a0a] relative overflow-hidden">
      {/* Abstract Shapes */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/3 h-full bg-gradient-to-l from-[#3affc2]/5 to-transparent pointer-events-none" />

      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#68b8ff]/10 text-[#68b8ff] text-xs font-bold mb-6">
              <Shield className="w-3 h-3" />
              MODERN WIREGUARD ENCRYPTION
            </div>
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-white">Privacy & Security First</h2>
            <p className="text-gray-400 text-lg mb-6 leading-relaxed">
              When you connect to PhantomPathVPN, your VPN traffic is protected in transit using WireGuard's modern cryptography. This helps shield the contents of your connection from ISP inspection and data snooping on public or shared networks.
            </p>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed">
              PhantomPath does not retain browsing activity, DNS queries or VPN traffic content. Every access code is stateless and exists only for the duration of the purchased session.
            </p>

          </div>

          <div className="privacy-security-visual-column flex-1 relative">
            <div className="privacy-security-visual relative z-10 bg-gradient-to-br from-[#151515] to-[#0d0d0d] p-1 rounded-3xl border border-white/10">
               <div className="privacy-security-visual-inner bg-[#0a0a0a] rounded-[22px] overflow-hidden aspect-video flex items-center justify-center relative">
                 <div className="absolute inset-0 bg-[url('/noise.svg')] opacity-20"></div>
                 <div className="w-24 h-24 rounded-full bg-[#68b8ff]/20 flex items-center justify-center">
                   <Shield className="w-12 h-12 text-[#68b8ff]" />
                 </div>
                 <div className="privacy-security-status-row absolute bottom-6 left-6 right-6 flex justify-between text-xs text-gray-500 font-mono">
                    <span>LOCKED</span>
                    <span>IP ROUTED</span>
                 </div>
               </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacySecurity;
